import { NavLink } from "react-router-dom";
import { cn } from "@/lib/cn";
import { HQ_NAV_MODULES } from "./nav-config";
import styles from "./shell.module.css";

export interface SidebarProps {
  collapsed?: boolean;
}

export function Sidebar({ collapsed = false }: SidebarProps) {
  return (
    <aside className={styles.sidebar} aria-label="Primary">
      <div className={styles.brand}>
        <span className={styles.brandMark} aria-hidden>
          H
        </span>
        {!collapsed ? <span className={styles.brandText}>HUDDL HQ</span> : null}
      </div>
      <nav className={styles.nav} aria-label="Modules">
        <div className={styles.navGroupLabel}>Modules</div>
        {HQ_NAV_MODULES.map((module) =>
          module.available ? (
            <NavLink
              key={module.id}
              to={module.path}
              className={({ isActive }) =>
                cn(styles.navItem, isActive && styles.navItemActive)
              }
            >
              {!collapsed ? module.label : module.label.slice(0, 1)}
            </NavLink>
          ) : (
            <button
              key={module.id}
              type="button"
              className={cn(styles.navItem, styles.navItemDisabled)}
              disabled
              title="Available in a later Phase K wave"
              aria-disabled="true"
            >
              {!collapsed ? module.label : module.label.slice(0, 1)}
            </button>
          ),
        )}
      </nav>
    </aside>
  );
}
